import { Property } from "@/features/survey/types";
import { getIconData } from "@/shared/utils/map";
import { getPropertyOrderWithoutCurrentLocation } from "@/shared/utils/propertyUtils";

export const getIconColor = (property: Property): string => {
  return getIconData(property).iconColor;
};

export const getMenuMarkerContent = (
  property: Property,
  properties: Property[] = [],
): string | number => {
  const orderIndex = getPropertyOrderWithoutCurrentLocation(
    property.id.toString(),
    properties,
  );
  return orderIndex !== -1 ? orderIndex + 1 : "?";
};

export const getPdfUrl = (pdf: unknown): string => {
  const pdfObj = pdf as {
    mediaUrl?: string;
    url?: string;
    cloudfrontUrl?: string;
    pdfUrl?: string;
  };

  return (
    pdfObj.mediaUrl ||
    pdfObj.url ||
    pdfObj.cloudfrontUrl ||
    pdfObj.pdfUrl ||
    ""
  );
};

interface MenuItem {
  path: string;
  label: string;
  name?: string;
}

interface PageTitleParams {
  updatedMenuItems: MenuItem[];
  propertyId?: string;
  properties?: Property[];
  pathname: string;
  isActiveMenuItem: (path: string) => boolean;
}

export const getCurrentPageTitle = ({
  updatedMenuItems,
  propertyId,
  properties,
  pathname,
  isActiveMenuItem,
}: PageTitleParams): string => {
  const currentItem = updatedMenuItems.find((item) =>
    isActiveMenuItem(item?.path),
  );

  if (currentItem) {
    if (currentItem.label === "Properties" && propertyId && properties) {
      const currentProperty = properties.find(
        (p) => p.id.toString() === propertyId,
      );
      if (currentProperty) {
        return (
          currentProperty.propertyName ||
          currentProperty.name ||
          `Property ${propertyId}`
        );
      }
    }
    return currentItem.label;
  }

  // Fallback based on URL path
  if (pathname.includes("/cover")) return "Overview";
  if (pathname.includes("/marketmap")) return "Market Map";
  if (pathname.includes("/comparison")) return "Property Comparison";
  if (pathname.includes("/property/")) return "Property";
  if (pathname.includes("/tour")) return "Tour Schedule";
  if (pathname.includes("/leasecomps")) return "Lease Comps";

  return "Survey";
};
